// extracted by mini-css-extract-plugin
export default {"title":"EditTaskDocument_title__SBk46","uploadIconWrap":"EditTaskDocument_uploadIconWrap__K71AT"};